import { Box, GridItem, HStack, Image, position, Text, useTheme } from "@chakra-ui/react";
import { useAppContext } from "../../../App";
import { useState } from "react";
import { ChevronDownIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { splitGivenDescription } from "../../../utils/functions";
import ButtonMore from "../../buttonMore/buttonMore";

export default function CertificactionCard({ item, index }) {
  const { isMobile } = useAppContext();
  const theme = useTheme();
  const style = styles(theme, isMobile);
  const [openDrop, setOpenDrop] = useState(false);
  const [description, setDescription] = useState(splitGivenDescription(item.description));
  return (
    <GridItem
      key={item?.id || `inspired-card-${index}`}
      display="flex"
      flexDirection={"column"}
      alignItems="flex-start"
      width={"100%"}
      borderRadius={0}
      borderColor={theme.color.text.secondary}
      borderRightWidth={isMobile? 0 : index % 2 === 0 ? 1 : 0}
      borderBottomWidth={1}
    >
      <HStack
        width={"100%"}
        spacing={4}
        display={"flex"}
        alignSelf="flex-start"
        justifyContent={"flex-start"}
        onClick={() => setOpenDrop(!openDrop)}
      >
      <Image
        src={item.imgSrc}
        alt={`img-certification-card-${index}`}
        padding={"1%"}
        width={isMobile ? "90px" : "150px"}
        height={isMobile ? "60px" : "100px"}
        objectFit="contain"
        display="block"
/>
        {openDrop ? (
          <ChevronDownIcon
            color={theme.color.text.secondary}
            width={"4vh"}
            height={"4vh"}
          />
        ) : (
          <ChevronRightIcon
            color={theme.color.text.secondary}
            width={"4vh"}
            height={"4vh"}
          />
        )}
      </HStack>
      {openDrop && (
        <Box display={'flex'} flexDirection={'column'} justifyContent={'space-between'} >
          <div style={style.descriptionContainer} className="sansation-bold">
            <Text style={style.description(1)}>{description.text1}</Text>
            <Text style={style.description(2)}>{description.text2}</Text>
          </div>
          <ButtonMore
            buttonText="CONOCER MÁS"
            customStyles={{
              container: {
                width: isMobile? "50%" : "30%",
                marginTop: "1rem",
                marginBottom: "1rem",
                padding: "2%"
              },
              text:{
                fontSize: isMobile? "0.8rem" : '18px'
              },
              arrowSvg: isMobile? {
                height: "70%",
              }:{}
            }}
          />
        </Box>
      )}
    </GridItem>
  );
}
  const styles = (theme, isMobile) => ({
    container:{},
    descriptionContainer: {
      paddingTop: "2vh",
      paddingRight: "2vw",
      fontSize: "1rem",
      minHeight: "35vh",
      color: theme.color.text.tertiary,
    },
    description: (textNbr) => ({
      fontSize: isMobile? "1rem" :"1.5rem",
      lineHeight: 1.2,
      color: textNbr === 1? theme.color.text.secondary : theme.color.text.tertiary
    })
  })